import { render } from "./ActivateNewAccountVx.vue?vue&type=template&id=efe38246&scoped=true"
import script from "./ActivateNewAccountVx.vue?vue&type=script&lang=js"
export * from "./ActivateNewAccountVx.vue?vue&type=script&lang=js"

import "./ActivateNewAccountVx.vue?vue&type=style&index=0&id=efe38246&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TimSpule\\source\\repos\\peacoq\\Schaltzeit\\ScoutDB\\CisLogic.ScoutDB.UI.Esa\\app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efe38246"]])

export default __exports__